import { jsx as _jsx } from "react/jsx-runtime";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const APP_TREE_LOCAL_STATE_INHERIT_KEYS = [
    "isMoveable",
    "setIsMoveable",
    "isWPAttachmentsSortMode",
    "setIsWPAttachmentsSortMode",
    "showProFeature",
    "setShowProFeature",
    "rearrangeBoxId",
    "setRearrangeBoxId",
    "resolvedInitialSelectedId",
    "setResolvedInitialSelectedId",
    "controllerState",
    "setStatePatch"
];
const APP_TREE_LOCAL_STATE_SYMBOL = Symbol();
const useAppTreeLocalState = ()=>useImmutableContext(APP_TREE_LOCAL_STATE_SYMBOL);
function useAppTreeLocalStateProvider(value) {
    return useImmutableContextProvider(APP_TREE_LOCAL_STATE_SYMBOL, value, {}, {
        inherit: [
            ...APP_TREE_LOCAL_STATE_INHERIT_KEYS
        ]
    });
}
const AppTreeLocalStateProvider = ({ children, value })=>{
    const [Provider, contextValue] = useAppTreeLocalStateProvider(value);
    return /*#__PURE__*/ _jsx(Provider, {
        value: contextValue,
        children: children
    });
};
export { AppTreeLocalStateProvider, useAppTreeLocalState };
